export default __webpack_public_path__ + "static/media/css-sprites@2x.9e516ee7.png";